import {Input} from "@/components/ui/input";
import {useFormContext} from "react-hook-form";
import {ComponentProps, ReactNode} from "react";
import {LabelField, LabelFieldProps} from "@/components/form/LabelField";
import {User} from "lucide-react";
import {Slot, Slottable} from "@radix-ui/react-slot";
import {cn} from "../../lib/utils";

type TextFieldProps = ComponentProps<typeof Input> & LabelFieldProps & {
    icon?: ReactNode
}

export function TextField({label,

                              name, icon,className, containerClassName, hideError, ...props}: TextFieldProps) {
    const form = useFormContext()
    return (
        <LabelField label={label} name={name} containerClassName={containerClassName} hideError={hideError}>
            <div className="relative">
                {icon && <Slot className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground">
                    {icon}
                </Slot>}
                <Slottable >
                    <Input
                        id={name}
                        {...form.register(name)}
                        className={cn(icon && "pl-8", className)}
                        {...props}
                    />
                </Slottable>
            </div>
        </LabelField>
    )
}

TextField.displayName = "TextField";

